<template>
  <pie-chart
    v-if="gradeChart"
    key="gradeChart"
    :chart-data="gradeChart"
    :tooltips-callback-cfg="tooltipsCallbackCfg"
    :width="width"
    :height="height"
  ></pie-chart>
</template>
<script>
import PieChart from "@/components/Base/PieChart";
import { COLOR_OPTION_GRADE } from "@/helpers/color-chart-config";

export default {
  name: "grade-chart-admin",
  components: { PieChart },
  props: ["grade", "width", "height"],
  data() {
    return {
      tooltipsCallbackCfg: {
        title: {
          prefix: "Grade"
        },
        label: true,
        afterLabel: {
          subfix: "students"
        }
      }
    };
  },
  computed: {
    gradeChart() {
      return this.generateGradeChart(this.grade);
    }
  },
  methods: {
    generateGradeChart(dataGrade) {
      if (!dataGrade) return null;

      const { label, data } = dataGrade;
      return {
        labels: label,
        datasets: [
          {
            data,
            backgroundColor: label.map(label => COLOR_OPTION_GRADE[label]),
            borderWidth: 1
          }
        ]
      };
    }
  }
};
</script>
